import en from "commonAssets/i18n/en";

/**
 * Site i18n. Spreads the shared `en` strings and overrides only the
 * deficiency-portal confirmation copy so the Fix a Claim flow reads as a
 * "Deficiency Response" rather than a claim (Ops WP-1415).
 */
export default {
    en: {
        ...en,
        confirmation_page: {
            ...en.confirmation_page,
            title: "Your Deficiency Response has been submitted successfully.",
        },
        confirmation_this_is_a_copy:
            "THIS IS A COPY OF YOUR DEFICIENCY RESPONSE.",
        confirmation_screen_additional: {
            ...en.confirmation_screen_additional,
            body: en.confirmation_screen_additional.body.replace(
                "copy of your claim via email",
                "copy of your submission via email"
            ),
        },
    },
};
